import { Route, Routes } from 'react-router-dom';

// Analysis pages
import { AnalysisDetailPage } from '@/features/analysisPage/components/AnalysisDetailPage';
import { ProductSearchPage } from '@/features/productSearch/components/ProductSearchPage';
import { TrendPage } from '@/features/trend/components/TrendPage';
import { VeilleDetailPage } from '@/features/veille/components/VeilleDetailPage';
import { VeillePage } from '@/features/veille/components/VeillePage';
import { VendorSearchPage } from '@/features/vendorSearch/components/VendorSearchPage';
import { AnalysisPublicPage } from '@/pages/AnalysisPublicPage';
import { ContactPage } from '@/pages/ContactPage';
import { HomePage } from '@/pages/HomePage';
import { ManageUserAccountPage } from '@/pages/ManageUserAccount';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { SignInPage } from '@/pages/SignIn';
import { SignUpPage } from '@/pages/SignUp';
import { SubscriptionPage } from '@/pages/SubscriptionPage';
import { TestThemePage } from '@/pages/TestThemePage';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />
      <Route path="/manage-user-account/*" element={<ManageUserAccountPage />} />
      <Route path="/test-theme" element={<TestThemePage />} />
      <Route path="/subscription" element={<SubscriptionPage />} />
      <Route path="/contact" element={<ContactPage />} />

      {/* Analysis routes - le même composant gère la liste et le détail */}
      <Route path="/analysis/products" element={<ProductSearchPage />} />
      <Route path="/analysis/products/:id" element={<AnalysisDetailPage />} />
      <Route path="/analysis/products/:id/tab/:tab" element={<AnalysisDetailPage />} />
      <Route path="/analysis/vendors" element={<VendorSearchPage />} />
      <Route path="/analysis/vendors/:id" element={<AnalysisDetailPage />} />
      <Route path="/analysis/vendors/:id/tab/:tab" element={<AnalysisDetailPage />} />
      <Route path="/analysis/public" element={<AnalysisPublicPage />} />
      <Route path="/analysis/public/:id" element={<AnalysisPublicPage />} />
      <Route path="/analysis/public/:id/tab/:tab" element={<AnalysisPublicPage />} />

      {/* Veille (MOCK) - remplace l'entrée Publiques dans la nav */}
      <Route path="/veille" element={<VeillePage />} />
      <Route path="/trend" element={<TrendPage />} />
      <Route path="/veille/:id" element={<VeilleDetailPage />} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
